import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { Background, OTPInputComponent } from "../Login/LoginComp";
import { FloatLabelInput, LoadingButton } from "../../Utils/CustomComponent";
import useAuth from "../../auth/hooks/useAuth";
import { oracleConfig } from "../../Utils/constant";
import urls from "../../Utils/urls";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const VOMGateway = () => {
  const [otpEntered, setOtpEntered] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const isAuthenticated = useSelector(
    (state) => state.RS_Authentication.isAuthenticated,
  );
  const location = useLocation();

  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  // useEffect(() => {
  //   if (location.state?.error) {
  //     toast.error(location.state.error);
  //   }
  // }, []);

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  // const handleCaptchaSuccess = (status) => {
  //   if (status === "success") {
  //     setCaptchaVerified(true);
  //     handleSubmit(onSubmit)(); // continue form submission after captcha success
  //   } else {
  //     alert("Captcha verification failed");
  //   }
  // };

  // const handleContinueClick = () => {
  //   if (captchaRef.current) {
  //     captchaRef.current.executeCaptcha();
  //   }
  // };

  async function handleInitialLogin(email) {
    if (!captchaToken) {
      alert("Please complete the CAPTCHA");
      return;
    }
    setDisableBtn(true);

    try {
      const res2 = await axios.get(
        urls.manageApiKey.recapthcaForVOM(captchaToken),
      );

      if (res2?.data?.success) {
        const data = {
          email_address: email,
        };
        const res = await axios.post(urls.account.sendOtp, data, oracleConfig);

        if (res.status === 200 || res.status === "200") {
          setIsOtpStage(true);
          setShowOtpInput(true);
          setDisableBtn(false);
        } else {
          // console.log(res);
          // setPromptFail("Invalid email.");
          setDisableBtn(false);
        }
      } else {
        alert("CAPTCHA verification failed ❌");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function onSubmit(data) {
    setPromptFail("");
    try {
      if (isOtpStage) {
        setAfterOtpLoading(true);
        const newData = {
          email_address: data.email,
          otp: otpEntered,
        };
        // console.log({ newData });
        const res = await axios.post(
          // urls.account.validateOtp,
          urls.VOM.validateOTP,
          newData,
          oracleConfig,
        );
        // console.log({res})
        if (res.status === 200 || res.status === "200") {
          localStorage.setItem("vom_token", res?.data?.tokenForVOM);
          const data2 = {
            isAuthenticated: true,
            user: {
              email: data.email,
            },
          };
          // setAuth(data2);
          setAfterOtpLoading(false);
          // localStorage.setItem("apex_userid", "51787");
          localStorage.setItem("email_for_vom", data.email);
          // if (location?.pathname?.includes("/vom-gateway/borrower")) {
          //   navigate(`/vom/borrower/${data.email}`);
          // } else if (location?.pathname === "/vom-gateway") {
          // }
          navigate(`/vom/${data.email}`);
        } else {
          setPromptFail("Invalid OTP! Please try again.");
          setAfterOtpLoading(false);
        }
      } else {
        handleInitialLogin(data.email);
      }
    } catch (error) {
      console.error(error);
      setPromptFail("Invalid OTP! Please try again.");
    } finally {
      setAfterOtpLoading(false);
    }
  }

  return (
    <Background showFooter={false}>
      <form className="w-75">
        <h3>Request Verification of Mortgage</h3>
        <p className="pb-5 mb-3">
          Welcome! Please enter your email address to proceed.
        </p>

        <div className="form-outline mb-5">
          <FloatLabelInput
            register={{
              ...register("email", {
                required: true,
                pattern:
                  // eslint-disable-next-line no-useless-escape
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }),
            }}
            label={"Email"}
            value={watch("email")}
            error={errors.email ? "Email Required" : ""}
            type="email"
          />
        </div>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={"6LdCWmgsAAAAAD2OfKz0DqvanPavGilPc7oq9hlW"}
          onChange={handleCaptchaChange}
        />

        <div className="form-outline mb-1">
          {showOtpInput && (
            <>
              <OTPInputComponent
                setOtpEntered={setOtpEntered}
                setOtpReceived={() => {}}
                onClick={() => {}}
              />
            </>
          )}
        </div>

        <div className="text-center pt-1 mt-5 mb-5 pb-1">
          {showOtpInput ? (
            <LoadingButton
              className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
              type="button"
              onClick={handleSubmit(onSubmit)}
              title={"Verify OTP and Continue"}
              disabled={afterOtpLoading || otpEntered?.length !== 6}
              loading={afterOtpLoading}
            />
          ) : (
            <LoadingButton
              className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
              type="button"
              onClick={handleSubmit(onSubmit)}
              // onClick={handleContinueClick}
              disabled={disableBtn}
              loading={disableBtn}
              title={"Continue"}
            />
          )}

          {promptFail ? (
            <div className="alert alert-error" role="alert">
              {promptFail}
            </div>
          ) : null}
          <br />
        </div>
      </form>
    </Background>
  );
};

export default VOMGateway;
